import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Spin, Tag } from 'antd'
import { compose, graphql } from 'react-apollo'
import { inject, observer } from 'mobx-react'
// import { Redirect } from 'react-router-dom'
// import { FormattedMessage } from 'react-intl'
import _get from 'lodash/get'
// import moment from 'moment'
// import gql from 'graphql-tag'
import './styles.css'

import Img from './Components/Img'
// import EventName from './Components/EventName'
// import ShortDescription from './Components/ShortDescription'
import EntryFee from './Components/EntryFee'
// import Countdown from './Components/Countdown'
import Description from './Components/Description'
import eventPageFromSlugQuery from '~/App/graphql/queries/eventPageFromSlug.gql'
// import Race from './Components/Race'
// import Map from './Components/Map'
// import Remark from './Components/Remark'

// const { Content } = Layout
import localeGet from '~/App/utils/localeGet'
import { EventPageContent } from '~/styles'

import EventNotFound from '../pages/Error/EventNotfound'
class EventPage extends Component {
  render () {
    const { event, loading, i18n: { locale } } = this.props
    if (loading) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }
    if (!event) {
      return <EventNotFound />
    }
    if (event.redirectTo) {
      window.location.href = event.redirectTo // <Redirect to={event.redirectTo} />
      return null
    }
    const contentSections = _get(event, 'contentSections', [])
    return (
      <EventPageContent>
        {event.testMode && <div className="testMode">
          <Tag color="red">
            Test mode !!!
          </Tag>
        </div>}
        <div className="eventPage">
          <Img eventName={event.name} src={event.coverUrl} />
          <Row>
            {/* TODO: should pass the whole event? and set up appropriate prop types */}
            <EntryFee
              isRegOpen={event.isRegOpen}
              priceSource={_get(event, 'settings.payment.priceSource')}
              periods={event.periods}
              registrationTypes={event.registrationTypes}
              ticketTypes={event.ticketTypes}
              slug={event.slug}
              hideDate={event.hideDate}
              isSoldOut={event.isSoldOut}
              startDate={event.startDate}
              endDate={event.endDate}
              location={event.location}
              liveLegacy={event.liveLegacy}
              website={event.website}
              customMessage={_get(event, 'settings.registration.customMessage')}
              enterNotice={_get(event, 'settings.registration.enterNotice')}
              settings={event.settings}
              history={this.props.history}
            />
            {' '}
            {/* TODO: should pass event object for slug? or register link */}
            <Col md={{ span: 16, pull: 8 }}>
              {!event.hideDate && <Description
                description={localeGet(event, 'description', locale)}
                startDate={event.startDate}
                endDate={event.endDate}
                coverUrl={event.coverUrl}
              />}
              <div className="eventContent">
                {contentSections.map(section => (
                  <section key={section._id}>
                    <h1>{localeGet(section, 'title', locale)}</h1>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: localeGet(section, 'body', locale)
                      }}
                    />
                  </section>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </EventPageContent>
    )
  }
}

// EventPage
EventPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      eventSlug: PropTypes.string
    })
  }).isRequired
}

export default compose(
  inject('i18n'),
  graphql(eventPageFromSlugQuery, {
    options: props => ({
      variables: {
        slug: props.match.params.eventSlug
      }
    }),
    props: ({ data: { loading, eventPageFromSlug } }) => ({
      loading,
      event: eventPageFromSlug
    })
  }),
  observer
)(EventPage)



// WEBPACK FOOTER //
// ./src/App/EventPage/EventPage.js